import { compose } from '@beef/utils';
import { withOnScreenAnalytics } from "../../../_shared/utils/withOnScreenAnalytics";
import { getWindow } from "../../../_shared/utils/window";
import { getAccountType } from "../../../utils/analytics";
import { ymPushParams } from "../../../_shared/utils/ym";
import { CaptchaInput as _CaptchaInput } from "./CaptchaInput";
import { withCaptchaLogic } from "../enhancers/withCaptchaLogic";
import { getOnScreenAnalyticsHandler } from "./analytics";
export var CaptchaInput = compose(withCaptchaLogic, withOnScreenAnalytics(getOnScreenAnalyticsHandler({
  getWindow: getWindow,
  getAccountType: getAccountType,
  ymPushParams: ymPushParams
}), {
  shouldTriggerOnce: true,
  debounce: 100
}))(_CaptchaInput);